import { useQuery } from '@tanstack/react-query';
import {
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { UseQueryCustomResult } from '../types';
import { handleReponse } from '../helper';

const fetchConfiguredRegions = async (
  backendUrl: string,
  accessToken?: string,
): Promise<string[]> => {
  const response = await fetch(
    `${backendUrl}/api/bidone/configuration/available-regions`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    },
  );

  return handleReponse(response);
};

const useConfiguredRegions = (): UseQueryCustomResult<string[]> => {
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const backendUrl = config.getString('backend.baseUrl');

  return useQuery({
    queryKey: ['useCommon', 'useConfiguredRegions'],
    queryFn: async () => {
      const { token } = await identityApi.getCredentials();
      return fetchConfiguredRegions(backendUrl, token);
    },
  });
};

const fetchConfiguredEnvs = async (
  backendUrl: string,
  accessToken?: string,
): Promise<string[]> => {
  const response = await fetch(
    `${backendUrl}/api/bidone/configuration/available-environments`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    },
  );

  return handleReponse(response);
};

const useConfiguredEnvironments = (): UseQueryCustomResult<string[]> => {
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const backendUrl = config.getString('backend.baseUrl');

  return useQuery({
    queryKey: ['useCommon', 'useConfiguredEnvironments'],
    queryFn: async () => {
      const { token } = await identityApi.getCredentials();
      return fetchConfiguredEnvs(backendUrl, token);
    },
  });
};

export { useConfiguredRegions, useConfiguredEnvironments };
